/** Map AI assistant intent → search UI state / Smart Match intent */
export const mergeAssistantIntent = (baseIntent = {}, aiIntent = null) => {
  if (!aiIntent) return baseIntent;
  return {
    ...baseIntent,
    destination: aiIntent.destination || aiIntent.location || baseIntent.destination,
    location: aiIntent.destination || aiIntent.location || baseIntent.location,
    budgetMax: aiIntent.budgetMax ?? aiIntent.maxPrice ?? baseIntent.budgetMax,
    budgetMin: aiIntent.budgetMin ?? baseIntent.budgetMin,
    guests: aiIntent.guests || baseIntent.guests,
    guestType: aiIntent.guestType || aiIntent.tripPurpose || baseIntent.guestType,
    tripPurpose: aiIntent.tripPurpose || aiIntent.guestType || baseIntent.tripPurpose,
    amenities: aiIntent.amenities?.length ? aiIntent.amenities : baseIntent.amenities,
    checkIn: aiIntent.checkIn || baseIntent.checkIn,
    checkOut: aiIntent.checkOut || baseIntent.checkOut,
    bookingType: aiIntent.bookingType || baseIntent.bookingType,
  };
};

export const intentToSearchFilters = (intent = {}) => {
  const filters = {};
  const destination = intent.destination || intent.location;
  if (destination) filters.location = destination;
  if (intent.budgetMax) filters.priceRange = [0, Number(intent.budgetMax)];
  if (intent.amenities?.length) filters.amenities = intent.amenities;
  if (intent.guests) filters.guests = intent.guests;
  if (intent.checkIn) filters.checkIn = intent.checkIn;
  if (intent.checkOut) filters.checkOut = intent.checkOut;
  filters.sortBy = 'match';
  return filters;
};

export const persistAiSearchIntent = (payload) => {
  try {
    sessionStorage.setItem('aiSearchIntent', JSON.stringify(payload));
  } catch {
    /* ignore */
  }
};

export const readAiSearchIntent = () => {
  try {
    const raw = sessionStorage.getItem('aiSearchIntent');
    sessionStorage.removeItem('aiSearchIntent');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
